import {
  Component,
  Input,
  Output,
  EventEmitter,
  Inject,
  HostBinding
} from '@angular/core';
import * as _ from 'lodash';
import { DomSanitizer } from '@angular/platform-browser';

import { PermissionsService } from 'shared/permissions/permissions.service';

import { getColWidth } from '../search-helpers';
import { getRowStatusColor } from './status-renderer/status-helpers';


@Component({
  moduleId: module.id,
  selector: 'search-results',
  templateUrl: 'search-results.component.html',
  styleUrls: ['search-results.component.scss']
})
export class SearchResultsComponent {
  @Input() rows: Array<{}> = [];
  @Input() columns: Array<{}> = [];
  @Input() disableItemSelect: boolean = false;
  @Input() loading: boolean = false;
  @Input() rowsHover: boolean = true;
  @Input() rowStatusHidden: boolean = false;
  @Input() listFilters: Array<any> = [];
  @Input() showEmptyState: boolean = true; // for compatibility with new index, fitments, DAM
  @Input() emptyListText: string;
  @Input() noResultsText: string = 'No results';
  @Input() selectable: boolean = false;
  @Input() small: boolean = false;
  @Input() smallest: boolean = false;
  @Input() detailsBtnText: string = 'View details';
  @Input() isVersion2: boolean = false;
  @Input() hideActionButton: boolean = false;
  @Input() alwaysShowActionButton: boolean = false;
  @Input() statusColorMap: any; // Possibility to redefine status colors in the status-renderer
  @Input() colCssProcess: boolean = false; // New way of handling col width (with colCssWidth field)
  @Input() isCheckboxVersion2: boolean = false; // new checkboxes
  @Input() dateFormatStr: string = 'MM/DD/YYYY';

  @HostBinding('class.statuses-removed')
  @Input() statusesRemoved: boolean = false; // remove status renderer from DOM
  @Input() isIndexPage: boolean = false; // display status as line, not dot
  @Input() timezone: any;

  @Output() changeCheckbox = new EventEmitter<{}>();
  @Output() detailsBtnClick = new EventEmitter<{}>();
  @Output() rowClick = new EventEmitter<{}>();
  @Output() checkboxClick = new EventEmitter<{}>();
  @Output() linkClick = new EventEmitter<{}>();
  @Output() btnClick = new EventEmitter<{}>();
  @Output() cellClick = new EventEmitter<{}>();
  @Output() changeFormControl = new EventEmitter<{}>();

  debouncedCheckboxClick = _.debounce(this.emitCheckboxClick, 50);

  constructor(
    protected sanitizer: DomSanitizer,
    protected permissionsService: PermissionsService,
  ) {}

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public getColumnValue(row, column): string {
    if (column.data) {
      return column.data(row);
    }
    return _.get(row, column.col);
  }

  public getStatusColor(row: any): string {
    return getRowStatusColor(this.statusColorMap, row, this.isIndexPage);
  }

  public hasPermissions(column: any) {
    if (!column.showPermissions) { return true; }
    return this.permissionsService.hasPermission(column.showPermissions);
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onCheckboxChange(event: any, column: any) {
    column.selected = event.target.checked;
    this.changeCheckbox.emit(column);
  }

  onClickDetailsBtn(row: any) {
    localStorage.setItem('scrollTop', window.pageYOffset.toString());
    this.detailsBtnClick.emit(row._id);
  }

  onRowClick(row: any) {
    if (this.selectable) {
      row.selected = !row.selected;
    }
    this.rowClick.emit(row);
  }

  onCheckboxClick(event: any, row: any) {
    this.debouncedCheckboxClick(row);
  }

  onLinkClick($event: any) {
    this.linkClick.emit($event);
  }

  onBtnClick($event: any) {
    this.btnClick.emit($event);
  }

  onCellClick(row: any, column: any) {
    this.cellClick.emit({row, column});
  }

  onChangeFormControl(event) {
    this.changeFormControl.emit(event);
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private emitCheckboxClick(row: any) {
    this.checkboxClick.emit(row);
  }

  private getColCssWidth(col: any) {
    if (this.columns) {
      return this.sanitizer.bypassSecurityTrustStyle(getColWidth(col, this.columns));
    } else {
      return '';
    }
  }
}
